var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full",attrs:{"id":"map"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }_vm.clearActiveSites;
    _vm.clearSelectedSites;}}})}
var staticRenderFns = []

export { render, staticRenderFns }